<template>
  <ModalDialog
    :header-text="headerText"
    :open="open"
    @close-modal="closeModal"
    data-cy="email-form-modal"
  >
    <template v-slot:content>
      <EmailForm
        :callerType="callerType"
        :emailRecipient="emailRecipient"
        :companyName="companyName"
        :plantName="plantName"
        :assignmentId="assignmentId"
        @formSubmitted="closeModal"
      />
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import { EmailFormCallerType } from "@/Domain/EmailFormCallerType";
import { computed } from "vue";
import EmailForm from "@/shared/ui/forms/EmailForm.vue";

const props = defineProps<{
  open: boolean;
  callerType: EmailFormCallerType;
  emailRecipient?: string;
  companyName?: string;
  plantName?: string;
  assignmentId?: number;
}>();

const emit = defineEmits(["closeModal"]);

const headerText = computed(() => {
  if (props.callerType == EmailFormCallerType.RfrAssignmentsRequest)
    return "RFR Assignments Email";
  return "Contact Us";
});

const closeModal = function () {
  emit("closeModal");
};
</script>

<style lang="scss">
.email-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  gap: 16px;

  @include media-breakpoint-up(sm) {
    width: 500px;
  }

  .message-textarea {
    resize: vertical;
  }

  .inline-form-control {
    display: flex;
    margin-bottom: 1rem;
    align-items: center;

    label {
      height: 36px;
      line-height: 24px;
      font-size: 1rem;
      background: #f7f7f7;
      padding: 5px 10px;
      border-radius: 4px 0 0 4px;
      border: 1px solid #ddd;
      padding-right: 24px;
      flex-basis: 25%;
    }

    input {
      height: 36px;
      padding: 0.5rem;
      border: 1px solid #ccc;
      font-size: 1rem;
      border-radius: 0 4px 4px 0;
      width: 100%;
      flex-basis: 75%;
    }
  }

  .k-svg-icon {
    width: 16px;
    height: 16px;
  }

  .holiday-message {
    display: block;
    text-align: center;
    padding: 5px;
    margin: 10px 0;
    background: #fff1d9;
    color: #a99c85;
    border: 1px solid #e8d9c0;
  }
}
</style>
